<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Ratings</label>
  <span class="spacer"></span>
  @if (canExpand) {
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  }
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (unitTypeSelection) {
          <span>
            <label class="halfWidthInputLabel">Unit Type:</label>
            <select class="halfWidthInputField" #unitTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitTypeSelection.Name)"
              (change)="selectedValueChanged(unitTypeSelection.Name, unitTypeInput.value)"
              [value]="unitTypeSelection.Value.toString()">
              @for (allowable of unitTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="unitTypeSelection.Value && unitTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (sizeSelection) {
          <span>
            <label class="halfWidthInputLabel">Size:</label>
            <select class="halfWidthInputField" #unitSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(sizeSelection.Name)"
              (change)="selectedValueChanged(sizeSelection.Name, unitSizeInput.value)"
              [value]="sizeSelection.Value.toString()">
              @for (allowable of sizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="sizeSelection.Value && sizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (systemTypeSelection) {
          <span>
            <label class="halfWidthInputLabel">System Type:</label>
            <select class="halfWidthInputField" [disabled]="true"
              [value]="systemTypeSelection.Value.toString()">
              @for (allowable of systemTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="systemTypeSelection.Value && systemTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (coilRowsSelection) {
          <span>
            <label class="halfWidthInputLabel">Coil Rows:</label>
            <select class="halfWidthInputField" #coilRowsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilRowsSelection.Name)"
              (change)="selectedValueChanged(coilRowsSelection.Name, coilRowsInput.value)"
              [value]="coilRowsSelection.Value.toString()">
              @for (allowable of coilRowsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="coilRowsSelection.Value && coilRowsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (unitVoltageSelection) {
          <span>
            <label class="halfWidthInputLabel">Unit Voltage:</label>
            <select class="halfWidthInputField" #unitVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
              (change)="selectedValueChanged(unitVoltageSelection.Name, unitVoltageInput.value)"
              [value]="unitVoltageSelection.Value.toString()">
              @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (tubeWallThickness) {
          <span>
            <label class="halfWidthInputLabel">Tube Wall Thickness:</label>
            <select class="halfWidthInputField" #tubeWallThicknessInput
              [class.invalidConfigurationSelection]="isInvalidSelection(tubeWallThickness.Name)"
              (change)="selectedValueChanged(tubeWallThickness.Name, tubeWallThicknessInput.value)"
              [value]="tubeWallThickness.Value.toString()">
              @for (allowable of tubeWallThickness.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="tubeWallThickness.Value && tubeWallThickness.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (electricHeatSelection) {
          <span>
            <label class="halfWidthInputLabel">Electric Heat KW:</label>
            <select class="halfWidthInputField" #electricHeatInput
              [class.invalidConfigurationSelection]="isInvalidSelection(electricHeatSelection.Name)"
              (change)="selectedValueChanged(electricHeatSelection.Name, electricHeatInput.value)"
              [value]="electricHeatSelection.Value.toString()">
              @for (allowable of electricHeatSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="electricHeatSelection.Value && electricHeatSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (motorType) {
          <span>
            <label class="halfWidthInputLabel">Motor Type:</label>
            <select class="halfWidthInputField" #motorTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(motorType.Name)"
              (change)="selectedValueChanged(motorType.Name, motorTypeInput.value)"
              [value]="motorType.Value.toString()">
              @for (allowable of motorType.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="motorType.Value && motorType.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
